/* eslint-disable import/prefer-default-export */
import Big from 'big.js';
import { forEach } from 'lodash';
import { useCallback } from 'react';
import { sharingInformationService } from '../../../../services/sharingInformationService';

export const useCreateOrderNote = ({
  orderSaved,
  retailerInfo,
  saveAction,
  getValues,
  createOrderMessage
}) => {
  const createOrderNote = useCallback(() => {
    const orderFormData = getValues();
    const { subtotal, tax, total } = getValues('orderSummary');

    const orderHowMessage = {
      order_id: orderSaved.id,
      web_id: orderSaved.web_id,
      sequential_number: orderSaved.sequential_number,
      currency: orderSaved.currency,
      address: orderSaved.address,
      city: orderSaved.city,
      state: orderSaved.state,
      country: orderSaved.country,
      zip_code: orderSaved.zip_code,
      created_at: orderSaved.created_at,
      products: [],
      retailer_tax: retailerInfo.tax_amount ? retailerInfo.tax_amount : 0,
      subtotal,
      shipping_value: orderFormData.shipping_value,
      tax,
      total,
      total_discount: orderSaved.total_discount,
      discount_reason: orderSaved.discount_reason,
      notes: orderFormData.notes,
      delivery_method: orderFormData.delivery_method,
      customer: orderFormData.customer,
      saveAction,
      subtotal_with_discount: Big(Number(subtotal)).minus(Number(orderSaved.total_discount)).round(2).toNumber(),
      customer_id: orderSaved.customer?.id_in_mercately
    };

    forEach(orderSaved.order_items, (item) => {
      const newProduct = {
        id: item.product_id,
        custom_tax: item.custom_tax,
        title: item.title,
        variant_name: item.variant_name,
        quantity: item.quantity,
        unit_price: item.unit_price,
        total_discount: item.total_discount,
        total: Number(Big(item.quantity).times(Number(item.unit_price)).sub(Number(item.total_discount)).round(2)),
        variants: []
      };

      forEach(item.order_item_variants, (variant) => {
        newProduct.variants.push({
          variant_id: variant.variant_id,
          variant_name: variant.variant_name,
          variant_option_id: variant.variant_option_id,
          variant_option_name: variant.variant_option_name
        });
      });

      orderHowMessage.products.push(newProduct);
    });

    createOrderMessage?.(orderHowMessage);
    // Enviar orden al chat usando sharingInformationService
    sharingInformationService.setSubject({
      orderMessage: orderHowMessage,
      reloadOrders: true
    });
    // Limpiar el estado después del envío
    sharingInformationService.setSubject({});

  }, [orderSaved, retailerInfo, saveAction, getValues, createOrderMessage]);

  return { createOrderNote };
};
